import { createSlice } from "@reduxjs/toolkit";

const workflowSlice = createSlice({
  name: "db4",
  initialState: {
    clientAppointments: [],
    pageSize: 50,
    displayArchiveOnly: false,
    archivedClientAppointments: [],
    historyClientAppointments: [],
  },
  reducers: {
    setClientAppointments(state, action) {
      const { clientAppointments = [] } = action.payload;
      state.clientAppointments = clientAppointments;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setDisplayArchiveOnly(state, action) {
      state.displayArchiveOnly = action.payload;
    },
    setArchivedClientAppointments(state, action) {
      const { archivedClientAppointments = [] } = action.payload;
      state.archivedClientAppointments = archivedClientAppointments;
    },
    setHistoryClientAppointments(state, action) {
      const { historyClientAppointments = [] } = action.payload;
      state.historyClientAppointments = historyClientAppointments;
    },
  },
});

export const {
  setClientAppointments,
  setPageSize,
  setDisplayArchiveOnly,
  setArchivedClientAppointments,
  setHistoryClientAppointments,
} = workflowSlice.actions;

export default workflowSlice.reducer;
